// @ts-check
import { ModuleProcessMappings } from '@erpagroapp/common';
import {
  ConfigurationParameterReturnType,
  ConfigurationParameterSource,
} from '../enums';
import { defineConfig, defineDefaultProps } from '../helpers';

const defaultProps = defineDefaultProps(/** @type {const} */ ({
  loadingRules: {
    requiredModuleIds: [
      ModuleProcessMappings.Repairs.Id,
    ],
    requiredProcessIds: [
      ModuleProcessMappings.Repairs.Processes.RepairParts.Id,
    ],
  },
}));

export function repairParts() {
  return defineConfig({
    EstadoDefectoPartesReparacion: {
      source: ConfigurationParameterSource.ERP,
      component: 'Produccion',
      returnType: ConfigurationParameterReturnType.STRING,
      defaultValue: null,
      ...defaultProps,
    },
    EstadoDefectoPartesReparacionCalle: {
      source: ConfigurationParameterSource.ERP,
      component: 'Produccion',
      returnType: ConfigurationParameterReturnType.STRING,
      defaultValue: null,
      ...defaultProps,
    },
    EstadoParteReapracionInicioDesplazamiento: {
      source: ConfigurationParameterSource.ERP,
      component: 'Produccion',
      returnType: ConfigurationParameterReturnType.STRING,
      defaultValue: null,
      ...defaultProps,
    },
    EstadoParteReparacionEnCliente: {
      source: ConfigurationParameterSource.ERP,
      component: 'Produccion',
      returnType: ConfigurationParameterReturnType.STRING,
      defaultValue: null,
      ...defaultProps,
    },
    EstadoValoracionDefectoParteReparacion: {
      source: ConfigurationParameterSource.ERP,
      component: 'Produccion',
      returnType: ConfigurationParameterReturnType.STRING,
      defaultValue: null,
      ...defaultProps,
    },
    EstadoFinalizacionDefectoParteReparacion: {
      source: ConfigurationParameterSource.ERP,
      component: 'Produccion',
      returnType: ConfigurationParameterReturnType.STRING,
      defaultValue: null,
      ...defaultProps,
    },
    ActividadProduccionDefectoReparaciones: {
      source: ConfigurationParameterSource.ERP,
      component: 'Produccion',
      returnType: ConfigurationParameterReturnType.NUMBER,
      defaultValue: null,
      ...defaultProps,
    },
    TipoLugarReparacionPorDefecto: {
      source: ConfigurationParameterSource.ERP,
      component: 'Produccion',
      returnType: ConfigurationParameterReturnType.NUMBER,
      defaultValue: null,
      ...defaultProps,
    },
    LineaProduccionDefectoReparaciones: {
      source: ConfigurationParameterSource.ERP,
      component: 'Produccion',
      returnType: ConfigurationParameterReturnType.NUMBER,
      defaultValue: null,
      ...defaultProps,
    },
    ArticuloConsumoReparacion: {
      source: ConfigurationParameterSource.ERP,
      component: 'Produccion',
      returnType: ConfigurationParameterReturnType.STRING,
      defaultValue: null,
      ...defaultProps,
    },
    ArticuloConsumoDesplazamiento: {
      source: ConfigurationParameterSource.ERP,
      component: 'Produccion',
      returnType: ConfigurationParameterReturnType.STRING,
      defaultValue: null,
      ...defaultProps,
    },
    PermitirModificarCantidadArticulosConsumidosReparaciones: {
      source: ConfigurationParameterSource.ERP,
      component: 'Produccion',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
    PermitirTrayectosMultiplesDiasParteReparacion: {
      source: ConfigurationParameterSource.ERP,
      component: 'Produccion',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
  });
}
